/** US-focused campaign/quiet-hours timezones — matches lead pipeline (Eastern/Central/Mountain/Pacific). */
export const CAMPAIGN_TIMEZONE_OPTIONS = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
  { value: 'UTC', label: 'UTC' },
] as const;

export function formatCampaignTimezoneLabel(timezone?: string | null): string {
  if (!timezone) return 'Eastern Time (ET)';
  const found = CAMPAIGN_TIMEZONE_OPTIONS.find((t) => t.value === timezone);
  return found?.label ?? timezone.replace(/_/g, ' ');
}

/** Lead timezone bucket targeted by a send-window IANA timezone (matches backend mapping). */
export function leadBucketForCampaignTimezone(timezone?: string | null): string | null {
  if (!timezone) return 'Eastern';
  const map: Record<string, string> = {
    'America/New_York': 'Eastern',
    'America/Chicago': 'Central',
    'America/Denver': 'Mountain',
    'America/Los_Angeles': 'Pacific',
    UTC: 'Unknown',
  };
  return map[timezone] ?? null;
}
